
const columns = () => {
    return [
        {
            title: '路径名称',
            name: 'name',
            dataIndex: 'name',
            searchItem: {},
            tableItem: {}
        },
        {
            title: '阶段数量',
            name: 'validStageCount',
            dataIndex: 'validStageCount',
            searchItem: {},
            tableItem: {
                width: 300
            }
        }
    ]
}

const tableApi = (api = {}) => {
    return {
        path: 'trainPath/pageList',
        ...api
    }
};

const user = (self, api) => {
    return {
        type: 'diy',
        initialValue: [],
        rowkey: 'id',
        columns: columns(),
        tableApi: tableApi(api),
    }
};

export default user
